import React, { Component } from "react";
import "./MCAWeight.css";
import Cookie from 'js-cookie';
// import EditableCell from '../components/EditableCell'
import {
    message, ConfigProvider, Divider,
    Table, Empty, Spin, InputNumber,Upload,
    Modal, Button, Form, Tooltip,Typography,
    Steps, Row, Col, Slider, Icon, Popover

} from 'antd';
import { Link } from "react-router-dom";
import ReactEcharts from 'echarts-for-react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import AHP from '../ahp'

const { Text, } = Typography;

const FormItem = Form.Item;

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
class EditableCell extends React.Component {
    state = {
        editing: false,
    }

    componentDidMount() {
        if (this.props.editable) {
            document.addEventListener('click', this.handleClickOutside, true);
        }
    }

    componentWillUnmount() {
        if (this.props.editable) {
            document.removeEventListener('click', this.handleClickOutside, true);
        }
    }

    toggleEdit = () => {
        const editing = !this.state.editing;
        this.setState({ editing }, () => {
            if (editing) {
                this.input.focus();
            }
        });
    }

    handleClickOutside = (e) => {
        const { editing } = this.state;
        if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
            this.save();
        }
    }

    save = () => {
        const { record, handleSave } = this.props;
        this.form.validateFields((error, values) => {
            if (error) {
                return;
            }
            this.toggleEdit();
            handleSave({ ...record, ...values });
        });
    }

    render() {
        const { editing } = this.state;
        const {
            editable,
            dataIndex,
            title,
            record,
            index,
            handleSave,
            ...restProps
        } = this.props;
        return (
            <td ref={node => (this.cell = node)} {...restProps}>
                {editable ? (
                    <EditableContext.Consumer>
                        {(form) => {
                            this.form = form;
                            return (
                                editing ? (
                                    <FormItem style={{ margin: 0 }}>
                                        {form.getFieldDecorator(dataIndex, {
                                            rules: [{
                                                required: true,
                                                message: `${title} is required.`,
                                            }],
                                            initialValue: record[dataIndex],
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={1}
                                                step={0.1}
                                                ref={node => (this.input = node)}
                                                onPressEnter={this.save}
                                            />
                                        )}
                                    </FormItem>
                                ) : (
                                        <div
                                            className="editable-cell-value-wrap"
                                            style={{ paddingRight: 24 }}
                                            onClick={this.toggleEdit}
                                        >
                                            {restProps.children}
                                        </div>
                                    )
                            );
                        }}
                    </EditableContext.Consumer>
                ) : restProps.children}
            </td>
        );
    }
}
//create pairwise modal
const PairwiseForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {

            const {
                visible, onCancel, onCreate, form, criteria, onNext
            } = this.props; //read all the property send from criteria

            const marks = {
                '-8': '9',
                '-7': '8',
                '-6': '7',
                '-5': '6',
                '-4': '5',
                '-3': '4',
                '-2': '3',
                '-1': '2',
                '-0': '1',
                '1': '2',
                '2': '3',
                '3': '4',
                '4': '5',
                '5': '6',
                '6': '7',
                '7': '8',
                '8': '9'
            };

            function formatter(value) {
                return `${Math.abs(value) + 1}`;
            }
            const { getFieldDecorator } = form; //can get the input value

            //print all the criteria group of this MCA
            const children = [];
            var seenDuplicate = false

            for (var i = 0; i < criteria.length - 1; i++) { // for criteria larger than 2
                if (criteria[i].children && criteria[i].children.length > 1) {
                    seenDuplicate = true
                }
                for (var j = i + 1; j < criteria.length; j++) {
                    if (criteria[j].children && criteria[j].children.length > 1) {
                        seenDuplicate = true
                    }
                    children.push(
                        <Row style={{ textAlign: "center" }} key={`${criteria[i].criteriaName}W%m$e${criteria[j].criteriaName}`} type="flex" justify="space-around">
                            <Col span={4}>
                                <p>{criteria[i].criteriaName}</p>
                            </Col>
                            <Col span={16}>
                                <Form.Item >
                                    {getFieldDecorator(`${criteria[i].criteriaName}W%m$e${criteria[j].criteriaName}`, { initialValue: 0 })(
                                        <Slider included={false} tipFormatter={formatter} marks={marks} min={-8} max={8} step={1} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <p>{criteria[j].criteriaName}</p>
                            </Col>
                        </Row>
                    );
                }
            }
            if (criteria.length === 1) {
                if (criteria[0].children && criteria[0].children.length > 1) {
                    seenDuplicate = true
                }
            }
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Pairwise comparison"
                    onCancel={onCancel}
                    onOk={seenDuplicate ? onNext : onCreate}
                    width={800}
                    okText={seenDuplicate ? "Next" : "Finish"}
                >
                    <Form layout="vertical">
                        <h4>Criteria group pairwise comparison</h4>
                        <div>&nbsp;</div>
                        {children}
                    </Form>
                </Modal>
            );
        }
    }
);


//create pairwise modal
const InGroupPairwiseForm = Form.create({ name: 'InGroup_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {

            const {
                visible, onCancel, onCreate, form, criteria
            } = this.props; //read all the property send from criteria



            function formatter(value) {
                return `${Math.abs(value) + 1}`;
            }

            const { getFieldDecorator } = form; //can get the input value

            //print all the criteria group of this MCA
            const children = [];
            for (let k in criteria) {
                if (criteria[k].children && criteria[k].children.length > 1) {
                    children.push(<h4 key={criteria[k].criteriaName}>SubCriteria pairwise comparison: <b>{criteria[k].criteriaName}</b>
                        <div>&nbsp;</div>
                    </h4>)
                    for (var i = 0; i < criteria[k].children.length - 1; i++) {
                        for (var j = i + 1; j < criteria[k].children.length; j++) {
                            children.push(
                                <Row style={{ textAlign: "center" }} key={`${criteria[k].criteriaName}W%m$e${criteria[k].children[i].criteriaName}W%m$e${criteria[k].children[j].criteriaName}`} type="flex" justify="space-around">
                                    <Col span={4}>
                                        <p>{criteria[k].children[i].criteriaName}</p>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item  >
                                            {getFieldDecorator(`${criteria[k].criteriaName}W%m$e${criteria[k].children[i].criteriaName}W%m$e${criteria[k].children[j].criteriaName}`, { initialValue: 0 })(
                                                <Slider included={false} tipFormatter={formatter} min={-8} max={8} step={1} />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <p>{criteria[k].children[j].criteriaName}</p>
                                    </Col>
                                </Row>
                            );
                        }

                    }
                }
                else { }
            }

            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Pairwise comparison"
                    okText="Finish"
                    onCancel={onCancel}
                    onOk={onCreate}
                    width={800}
                >
                    <Form layout="vertical">
                        {children}
                    </Form>
                </Modal>
            );
        }
    }
);

//create 100 scale modal
const ScaleForm = Form.create({ name: 'scale_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {

            const {
                visible, onCancel, onCreate, form, criteria, onNext
            } = this.props; //read all the property send from criteria


            function formatter(value) {
                return `${Math.abs(value)}`;
            }
            const { getFieldDecorator } = form; //can get the input value

            //print all the criteria group of this MCA
            const children = [];
            var seenDuplicate = false

            for (var i = 0; i < criteria.length; i++) {
                if (criteria[i].children && criteria[i].children.length !== 0) {
                    if (criteria[i].children.length > 1) {
                        seenDuplicate = true;
                    }
                }
                children.push(
                    <Row style={{ textAlign: "center" }} key={`${criteria[i].criteriaName}`} type="flex" justify="space-around">
                        <Col span={4}>
                            <p>{criteria[i].criteriaName}</p>
                        </Col>
                        <Col span={16}>
                            <Form.Item  >
                                {getFieldDecorator(`${criteria[i].criteriaName}`, {
                                    initialValue: 0
                                })(
                                    <Slider tipFormatter={formatter} included={false} />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                        {getFieldDecorator(`${criteria[i].criteriaName}`, {
                                    initialValue: 0
                                })(
                                    <InputNumber min={0} max={100}/>
                                )}
                        </Col>
                    </Row>
                );
            }
            if (criteria.length === 1) {
                if (criteria[0].children && criteria[0].children.length > 1) {
                    seenDuplicate = true
                }
            }
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Scale rating"
                    onCancel={onCancel}
                    onOk={seenDuplicate ? onNext : onCreate}
                    width={800}
                    okText={seenDuplicate ? "Next" : "Finish"}
                >
                    <Form layout="vertical">
                        <h4>Criteria group scale rating</h4>
                        <div>&nbsp;</div>
                        {children}
                    </Form>
                </Modal>
            );
        }
    }
);

//create 100 scale modal
const InGroupScaleForm = Form.create({ name: 'scale-InGroup_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {

            const {
                visible, onCancel, onCreate, form, criteria
            } = this.props; //read all the property send from criteria



            function formatter(value) {
                return `${Math.abs(value)}`;
            }

            const { getFieldDecorator } = form; //can get the input value

            //print all the criteria group of this MCA
            const children = [];
            for (let k in criteria) {
                if (criteria[k].children && criteria[k].children.length > 1) {
                    children.push(<h4 key={criteria[k].criteriaName}>SubCriteria scale rating: <b>{criteria[k].criteriaName}</b>
                        <div>&nbsp;</div>
                    </h4>)
                    for (var i = 0; i < criteria[k].children.length; i++) {
                        children.push(
                            <Row style={{ textAlign: "center" }} key={`${criteria[k].criteriaName}W%m$e${criteria[k].children[i].criteriaName}`} type="flex" justify="space-around">
                                <Col span={4}>
                                    <p>{criteria[k].children[i].criteriaName}</p>
                                </Col>
                                <Col span={16}>
                                    <Form.Item  >
                                        {getFieldDecorator(`${criteria[k].criteriaName}W%m$e${criteria[k].children[i].criteriaName}`, {
                                            initialValue: 0
                                        })(
                                            <Slider tipFormatter={formatter} included={false} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                {getFieldDecorator(`${criteria[k].criteriaName}W%m$e${criteria[k].children[i].criteriaName}`, {
                                    initialValue: 0
                                })(
                                    <InputNumber min={0} max={100}/>
                                )}
                                </Col>
                            </Row>
                        );
                    }
                }
                else { }
            }

            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Scale rating"
                    okText="Finish"
                    onCancel={onCancel}
                    onOk={onCreate}
                    width={800}
                >
                    <Form layout="vertical">
                        {children}
                    </Form>
                </Modal>
            );
        }
    }
);

export default class InvitedWeight extends Component {
    constructor(props) {
        super(props);

        this.columns = [{ //the column title of the table
            title: 'Criteria Name', //the title of column
            dataIndex: 'criteriaName', //the data index can be used for searching, filtering
            key: 'criteriaName',
            sorter: (a, b) => { if (a.criteriaName > b.criteriaName) { return -1; } if (a.criteriaName < b.criteriaName) { return 1; } return 0; },
            render: (text, record) => <Popover content={record.criteriaDescription} title="Description"><span style={{ cursor: "pointer" }}>{text}</span></Popover>, //make it clickable to the project
            width: '60%',
        },
        {
            title: 'Weight',
            key: 'criteriaWeight',
            dataIndex: 'criteriaWeight', //the data index can be used for searching, filtering
            sorter: (a, b) => { if (a.criteriaWeight > b.criteriaWeight) { return -1; } if (a.criteriaWeight < b.criteriaWeight) { return 1; } return 0; },
            width: '20%',
            editable: true,

        },
        {
            title: 'Action',
            key: 'action',
            width: '20%',
            render: (text, record) => (
                <span>
                    {/* save the edited alternative data, which will be used later in edit modal, and then show the edit modal */}
                    <Link to="#" onClick={() => { this.saveMCAWeightsAbs(record); }}> <span>
                        Keep this value &nbsp;
                            <Tooltip title="Keep this value of criterion, proportionally change other criteria">
                            <Icon type="question-circle-o" />
                        </Tooltip>
                    </span></Link>

                </span>
            ),
        }];


        this.state = {
            email: Cookie.get("email"),
            MCACriteria: [],
            MCACriteriaGroup: [],
            MCAid: "",
            totalWeight: 0,
            seenDuplicate: false,
            graphVisible: false,
            pairWiseVisible: false, //for pairwise modal
            inGroupPairWiseVisible: false, //for ingroup pairwise modal
            scaleVisible: false, //for scale modal
            inGroupScaleVisible: false, //for ingroup scale modal
            projectEvaluationType: "AHP",
            loading: true, //the loading status default true
            duplicateGroup: [], //group of criteria should be pairwise
            selectedCriterion: ""
        };
    }

    onStepChange = current => {
        if (current === 0) {
            this.props.history.push(`/invitedalternative/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if (current === 1) {
            this.props.history.push(`/invitedcriteria/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if (current === 3) {
            this.props.history.push(`/invitedevaluation/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
        if (current === 4) {
            this.props.history.push(`/invitedmamcaresult/${this.props.match.params.projectid}/${this.props.match.params.actorid}`)
        }
    }

    showGraph = () => {
        this.setState({
            graphVisible: true,
        });
    }

    handleGraphOk = (e) => {
        this.setState({
            graphVisible: false,
        });
    }
    handleGraphCancel = (e) => {
        this.setState({
            graphVisible: false,
        });
    }

    graphReset = () => {
        this.setState({
            selectedCriterion: ""
        })
    }
    getWeightOption = () => {
        let criteriaValue = []
        let criteriaName = []
        if (this.state.selectedCriterion !== "") {
            this.state.MCACriteria.forEach(obj => {
                if (obj.criteriaName === this.state.selectedCriterion) {
                    obj.children.forEach(subobj => {
                        criteriaName.push(subobj.criteriaName)
                        criteriaValue.push(subobj.criteriaWeight)
                    })
                }
            })
        }
        else {
            criteriaValue = [...[].concat(...this.state.MCACriteria.map(o => o.criteriaWeight))] //without set it can produce duplicated value
            criteriaName = this.state.MCACriteriaGroup
        }
        var option = {
            color: ['#4C6F74'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: criteriaName,
                    axisLabel: {
                        show: true,
                        interval: 0,
                        // Use callback function; function parameters are axis index
                        formatter: function (value, index) {
                            // let textArray = value.split(" ")
                            let final = ""
                            if(parseInt(value.length/20) === 0){ //not long enough
                                final = value
                            }
                            else{
                                for (let i = 0; i < parseInt(value.length/20)+1; i++) {
                                    let t = value.substring((i)*20, (i+1)*20)+ '\n';
                                    final += t
                                  }
                            }
 
                            // var texts = value.substring(0, 5);
                            return final;
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: 'Weight value',
                    type: 'bar',
                    barWidth: '60%',
                    data: criteriaValue
                }
            ]
        };
        return option
    }

    onEvents = () => {
        return ({
            click: (params) => { //click event
                this.state.MCACriteria.forEach(obj => {
                    if (obj.criteriaName === params.name && obj.children && obj.children.length !== 0) { //find the criterion, should have criteria group that can be expanded
                        this.setState({
                            selectedCriterion: params.name
                        })
                    }
                }
                )
            }
        })
    }

    handleSave = (row) => {
        const newData = [...this.state.MCACriteria];
        if (row.cid) {
            newData.forEach(obj => {
                if (obj._id === row.cid) {
                    const subindex = obj.children.findIndex(item => row._id === item._id);
                    const subitem = obj.children[subindex];
                    obj.children.splice(subindex, 1, {
                        ...subitem,
                        ...row,
                    });
                }
            })
            this.setState({ MCACriteria: newData });
        }
        else {
            const index = newData.findIndex(item => row._id === item._id);
            const item = newData[index];
            newData.splice(index, 1, {
                ...item,
                ...row,
            });
            this.setState({ MCACriteria: newData });
        }

    }

    //show or cancel pairwise modal
    showPairWiseModal = () => {
        this.setState({ pairWiseVisible: true });
    }

    handlePairWiseCancel = () => {
        this.setState({ pairWiseVisible: false });
    }

    //show or cancel create modal
    showInGroupPairWiseModal = () => {
        this.setState({ inGroupPairWiseVisible: true });
    }

    handleInGroupPairWiseCancel = () => {
        this.setState({ inGroupPairWiseVisible: false });
    }

    //show or cancel scale modal
    showScaleModal = () => {
        this.setState({ scaleVisible: true });
    }

    handleScaleCancel = () => {
        this.setState({ scaleVisible: false });
    }

    //show or cancel create modal
    showInGroupScaleModal = () => {
        this.setState({ inGroupScaleVisible: true });
    }

    handleInGroupScaleCancel = () => {
        this.setState({ inGroupScaleVisible: false });
    }


    handleNext = () => {
        this.setState({
            pairWiseVisible: false,
            inGroupPairWiseVisible: true
        });
    }

    handleScaleNext = () => {
        this.setState({
            scaleVisible: false,
            inGroupScaleVisible: true
        });
    }

    //create alternative
    handleCreate = () => {
        const form = this.formRef.props.form; //get all the data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err) {
                return;
            }
            else {
                if (this.state.seenDuplicate) { //there is sub-criterion
                    const Gform = this.GformRef.props.form; //get all the data from modal
                    Gform.validateFields((err, Gvalues) => { //can get values based on name
                        if (err) {
                            return;
                        }
                        else {
                            var pairwiseRank = []
                            for (var v in values) {
                                var match = v.split('W%m$e')
                                var n = values[v]

                                if (n < 0) {
                                    n = Math.abs(n) + 1 //convert to pairwise value
                                }
                                else {
                                    n = 1 / (Math.abs(n) + 1)
                                }

                                match.push(n)
                                pairwiseRank.push(match)
                            }
                            // const AHP = require('ahp');
                            var ahpContext = new AHP();
                            ahpContext.addItems(this.state.MCACriteriaGroup);
                            ahpContext.addCriteria(['weight']);
                            //rank criteria with rank scale
                            ahpContext.rankCriteriaItem('weight', pairwiseRank);
                            let output = ahpContext.run();
                            //  console.log(output.rankedScoreMap);

                            var test = []
                            var pairwise = {}
                            var firstname = ""
                            for (var g in Gvalues) {
                                var matchG = g.split('W%m$e') //split the keys
                                var t = {} //define an object
                                var p = g.substr(g.indexOf("W%m$e") + 5) //the rest of keys
                                t.pairwise = p
                                var q = Gvalues[g]
                                if (q < 0) {
                                    q = Math.abs(q) + 1 //convert to pairwise value
                                }
                                else {
                                    q = 1 / (Math.abs(q) + 1)
                                }
                                t.value = q
                                if (firstname === matchG[0]) {
                                    pairwise.pairwise.push(t) //if the name is the same, just add the array
                                }
                                else {
                                    test.push(pairwise) //if not, first push the previous group
                                    pairwise = {} //create a new object
                                    firstname = matchG[0]
                                    pairwise.group = firstname
                                    pairwise.pairwise = [t]
                                }
                            }
                            test.push(pairwise)//push the last group
                            test.shift()
                            var groupevaluation = []
                            for (var e in test) {
                                var groupE = {}
                                var result = { criteriaGroup: [...new Set([].concat(...test[e].pairwise.map(o => o.pairwise.split('W%m$e'))))] }
                                var ahpContextGroup = new AHP();
                                ahpContextGroup.addItems(result.criteriaGroup);
                                ahpContextGroup.addCriteria(['weight']);
                                //rank criteria with rank scale
                                var pair = test[e].pairwise
                                var pairA = []
                                //construct pairwise array
                                for (var u in pair) {
                                    var matchGP = pair[u].pairwise.split('W%m$e') //split the keys
                                    matchGP.push(pair[u].value)
                                    pairA.push(matchGP)
                                }
                                ahpContextGroup.rankCriteriaItem('weight', pairA);
                                let outputG = ahpContextGroup.run();
                                groupE.groupName = test[e].group
                                groupE.result = outputG.rankedScoreMap
                                //  console.log(outputG.rankedScoreMap);
                                groupevaluation.push(groupE)
                            }
                            fetch('/project/evaluateMAMCAWeights', { //REST create project
                                method: 'post',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    email: this.state.email,
                                    uid: this.props.match.params.projectid,
                                    actid: this.state.MCAid, //get the id of alternative
                                    evaluation: output.rankedScoreMap,
                                    groupEvaluation: groupevaluation,
                                }),
                            })
                                .then(res => res.json())
                                .then(json => {
                                    if (json.success) {
                                        this.getMCACriteria();
                                        message.success(json.message); //create successfully, show message
                                        this.setState({
                                            pairWiseVisible: false, //for pairwise modal
                                            inGroupPairWiseVisible: false
                                        }); //make modal invisible
                                        // form.resetFields(); //reset the form
                                    }
                                    else {
                                        message.error(json.message); //create unsuccessful, show alert
                                    }
                                });

                        }
                    });
                }
                else { //there is no sub-criterion
                    var pairwiseRank = []
                    for (var v in values) {
                        var match = v.split('W%m$e')
                        var n = values[v]

                        if (n < 0) {
                            n = Math.abs(n) + 1 //convert to pairwise value
                        }
                        else {
                            n = 1 / (Math.abs(n) + 1)
                        }

                        match.push(n)
                        pairwiseRank.push(match)
                    }
                    // const AHP = require('ahp');
                    var ahpContext = new AHP();
                    ahpContext.addItems(this.state.MCACriteriaGroup);
                    ahpContext.addCriteria(['weight']);
                    //rank criteria with rank scale
                    ahpContext.rankCriteriaItem('weight', pairwiseRank);
                    let output = ahpContext.run();
                    fetch('/project/evaluateMAMCAWeights', { //REST create project
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            email: this.state.email,
                            uid: this.props.match.params.projectid,
                            actid: this.state.MCAid, //get the id of alternative
                            evaluation: output.rankedScoreMap,
                            groupEvaluation: [],
                        }),
                    })
                        .then(res => res.json())
                        .then(json => {
                            if (json.success) {
                                this.getMCACriteria();
                                message.success(json.message); //create successfully, show message
                                this.setState({
                                    pairWiseVisible: false, //for pairwise modal
                                    inGroupPairWiseVisible: false,
                                }); //make modal invisible
                                // form.resetFields(); //reset the form
                            }
                            else {
                                message.error(json.message); //create unsuccessful, show alert
                            }
                        });
                }
            }
        });
    }
    //scale
    handleScaleCreate = () => {
        const form = this.SformRef.props.form; //get all the data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err) {
                return;
            }
            else {
                if (this.state.seenDuplicate) { //there is sub-criterion
                    const GSform = this.GSformRef.props.form; //get all the data from modal
                    GSform.validateFields((err, Gvalues) => { //can get values based on name
                        if (err) {
                            return;
                        }
                        else {
                            let evaluation = {}
                            var groupEvaluation = []
                            let zero = false
                            let groupname = "" //groupname
                            for (let g in Gvalues) { //regroup data
                                let matchG = g.split('W%m$e') //split the keys
                                let p = g.substr(g.indexOf("W%m$e") + 5) //the rest of keys
                                let t = {} //define an object
                                t[p] = Gvalues[g] //set the value
                                groupname = matchG[0]
                                let found = groupEvaluation.some(element => element.groupName === groupname); //find exist
                                // console.log(found)
                                if (found) {
                                    let locateSubgroup = groupEvaluation.find(element => element.groupName === groupname)
                                    locateSubgroup["result"][p] = Gvalues[g] //add value
                                }
                                else {
                                    let group = {} //create a new object
                                    group.groupName = groupname
                                    group.result = t
                                    groupEvaluation.push(group) //if not, first push the previous group
                                }
                            }
                            groupEvaluation.forEach(obj => {
                                let weight = 0
                                for (var gv in obj.result) {
                                    weight += obj.result[gv] //the total value in the group
                                }
                                if (weight === 0) {
                                    zero = true
                                }
                                for (var gval in obj.result) {
                                    obj.result[gval] = (obj.result[gval] / weight).toFixed(3)
                                }
                            })
                            let totalWeight = 0
                            // criteria group evaluation
                            for (var v in values) {
                                totalWeight += values[v]
                            }
                            if (totalWeight === 0 || zero) {
                                message.error("Please allocate the weights");
                            }
                            else {
                                for (var val in values) {
                                    evaluation[val] = (values[val] / totalWeight).toFixed(3)
                                }
                                fetch('/project/evaluateMAMCAWeights', { //REST create project
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        uid: this.props.match.params.projectid,
                                        email: this.state.email,
                                        actid: this.state.MCAid, //get the id of alternative
                                        evaluation: evaluation,
                                        groupEvaluation: groupEvaluation,
                                    }),
                                })
                                    .then(res => res.json())
                                    .then(json => {
                                        if (json.success) {
                                            this.getMCACriteria();
                                            message.success(json.message); //create successfully, show message
                                            this.setState({
                                                scaleVisible: false, //for pairwise modal
                                                inGroupScaleVisible: false,
                                            }); //make modal invisible
                                            // form.resetFields(); //reset the form
                                        }
                                        else {
                                            message.error(json.message); //create unsuccessful, show alert
                                        }
                                    });
                            }


                        }
                    })
                }
                else {
                    let evaluation = {}
                    let groupEvaluation = []
                    let weight = 0
                    for (var v in values) {
                        weight += values[v]
                    }
                    if (weight === 0) {
                        message.error("Please allocate the weights");
                    }
                    else {
                        for (var val in values) {
                            evaluation[val] = (values[val] / weight).toFixed(3)
                        }
                        this.state.MCACriteria.forEach(obj => {
                            if (obj.children && obj.children.length === 1) {
                                let group = {}
                                group.groupName = obj.criteriaName
                                group.result = []
                                let r = {}
                                r[obj.children[0].criteriaName] = 1
                                group.result.push(r)
                                groupEvaluation.push(group)
                            }
                        })
                        fetch('/project/evaluateMAMCAWeights', { //REST create project
                            method: 'post',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                uid: this.props.match.params.projectid,
                                email: this.state.email,
                                actid: this.state.MCAid, //get the id of alternative
                                evaluation: evaluation,
                                groupEvaluation: groupEvaluation,
                            }),
                        })
                            .then(res => res.json())
                            .then(json => {
                                if (json.success) {
                                    this.getMCACriteria();
                                    message.success(json.message); //create successfully, show message
                                    this.setState({
                                        scaleVisible: false, //for pairwise modal
                                        inGroupScaleVisible: false,
                                    }); //make modal invisible
                                    // form.resetFields(); //reset the form
                                }
                                else {
                                    message.error(json.message); //create unsuccessful, show alert
                                }
                            });
                    }
                }
            }
        })
    }

    //get the MCA criteria
    getMCACriteria = () => {
        fetch(`/invitedProject/getInvitedProjectCriteria/${this.props.match.params.projectid}/${this.props.match.params.actorid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    const result = [{ criteriaGroup: [...new Set([].concat(...json.MCACriteria.map(o => o.criteriaName)))] }]; //magic function for save unique criteria group in one list                   
                    json.MCACriteria.forEach(function (obj) {
                        obj.actors.forEach(aobj => { //find the actor who evaluates
                            if (aobj.actorEvaluator === Cookie.get("email")) {
                                if(aobj.actorCriteriaWeight){
                                    obj.criteriaWeight = aobj.actorCriteriaWeight.toFixed(3)
                                }
                            }
                        })
                        obj["children"] = obj.subCriteria
                        delete obj["subCriteria"];
                        obj.children.forEach(subobj => {
                            subobj["criteriaName"] = subobj.subCriteriaName
                            delete subobj["subCriteriaName"];
                            subobj["cid"] = obj._id
                            subobj["pCiteriaName"] = obj.criteriaName
                            subobj["criteriaIndicator"] = subobj.subCriteriaIndicator
                            delete subobj["subCriteriaIndicator"]
                            subobj["criteriaDescription"] = subobj.subCriteriaDescription
                            delete subobj["subCriteriaDescription"]
                            if (subobj.actors && subobj.actors.length !== 0) {
                                subobj.actors.forEach(subaobj => {
                                    if (subaobj.actorEvaluator === Cookie.get("email")) {
                                        if(subaobj.actorSubCriteriaWeight){
                                            subobj["criteriaWeight"] = subaobj.actorSubCriteriaWeight.toFixed(3)
                                            delete subaobj["actorSubCriteriaWeight"];//delete subaobj["subCriteriaWeight"];
                                        }
                                    }
                                })
                            }
                        })
                        if (obj.children.length === 0) {
                            delete obj["children"];
                        }
                    })
                    var seenDuplicate = false
                    for (var i = 0; i < json.MCACriteria.length; i++) {
                        if (json.MCACriteria[i].children && json.MCACriteria[i].children.length > 1) {
                            seenDuplicate = true
                        }
                    }
                    if (json.MCACriteria.length === 1) {
                        if (json.MCACriteria[0].children && json.MCACriteria[0].children.length > 1) {
                            seenDuplicate = true
                        }
                    }
                    this.setState({
                        MCACriteria: json.MCACriteria,
                        loading: false,
                        MCACriteriaGroup: result[0].criteriaGroup,
                        MCAid: json.MCAid,
                        projectName: json.projectName,
                        projectEvaluationType: json.projectEvaluationType,
                        role: json.role,
                        totalWeight: json.totalWeight,
                        seenDuplicate: seenDuplicate
                    }) //save project data
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }



   //export template excel
   downloadTemplate = () => {
    let headers = [ // Define headers
        { header: 'Criterion', key: 'criteriaName' },
        { header: 'Sub criterion', key: 'subCriteriaName' },
        { header: 'It is a criterion under which criterion?', key: 'mainCriteria' },
        { header: 'Criterion weight', key: 'actorCriteriaWeight' },
    ];
    let data = []
    // Check if fill the weights already
    let isFound = false // Find evaluator data
    if (Array.isArray(this.state.MCACriteria[0].subCriteria) && this.state.MCACriteria[0].subCriteria.length > 0) { // Has subcriteriin, so no need to care about criterion
        this.state.MCACriteria[0].subCriteria[0].actors.some(element => {
            if (element.actorEvaluator === this.state.email) { // There is selected evaluator
                isFound = true;
            }
        })
    } else {
        this.state.MCACriteria[0].actors.some(element => {
            if (element.actorEvaluator === this.state.email) { // There is selected evaluator
                isFound = true;
            }
        });
    }
    if (isFound) {
        this.state.MCACriteria.forEach(c => {
            let oneData = {}
            oneData.criteriaName = c.criteriaName
            oneData.subCriteriaName = '/'
            oneData.mainCriteria = '/'
            if (c.hasOwnProperty('actorCriteriaWeight')) { // There is value
                oneData.actorCriteriaWeight = c.actors.find(a => a.actorEvaluator === this.state.email).actorCriteriaWeight;
            }
            else {
                oneData.actorCriteriaWeight = 'Please fill the weight for this criterion'
            }
            data.push(oneData)
            if (Array.isArray(c.children) && c.children.length > 0) { // Has subcriteria
                c.children.forEach(child => {
                    let oneSubData = {}
                    oneSubData.criteriaName = '/'
                    oneSubData.subCriteriaName = child.criteriaName
                    oneSubData.mainCriteria = c.criteriaName
                    if (child.hasOwnProperty('actorSubCriteriaWeight')) {
                        oneSubData.actorCriteriaWeight = child.actors.find(a => a.actorEvaluator === this.state.email).actorSubCriteriaWeight
                    }
                    else {
                        oneSubData.actorCriteriaWeight = 'Please fill the weight for this sub criterion; The sum of the weights under one main criterion should be equal to 1'
                    }
                    data.push(oneSubData)
                })
            }

        })
    }
    else {
        this.state.MCACriteria.forEach(c => {
            let oneData = {}
            oneData.criteriaName = c.criteriaName
            oneData.subCriteriaName = '/'
            oneData.mainCriteria = '/'
            oneData.actorCriteriaWeight = 'Please fill the weight for this criterion'
            data.push(oneData)
            if (Array.isArray(c.children) && c.children.length > 0) { // Has subcriteria
                c.children.forEach(child => {
                    let oneSubData = {}
                    oneSubData.criteriaName = '/'
                    oneSubData.subCriteriaName = child.criteriaName
                    oneSubData.mainCriteria = c.criteriaName
                    oneSubData.actorCriteriaWeight = 'Please fill the weight for this sub criterion; The sum of the weights under one main criterion should be equal to 1'
                    data.push(oneSubData)
                })
            }

        })
    }
    let fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let fileExtension = '.xlsx';


    let ws = XLSX.utils.json_to_sheet(data);
    let ws_with_headers = XLSX.utils.sheet_add_aoa(ws, [headers.map(h => h.header)], { origin: 'A1' });

    let wb = { Sheets: { data: ws_with_headers }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    let dataBlob = new Blob([excelBuffer], { type: fileType });
    saveAs(dataBlob, `Criteria_weight_data${fileExtension}`);
}

//upload excel
uploadExcel = (file) => {
    const reader = new FileReader();
    let data = {};
    reader.onload = (evt) => {
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: 'binary' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        data = XLSX.utils.sheet_to_json(worksheet);

        if (data && data.length > 0) { //if there is data
            // Change status here, if needed
            // Confirm upload with user
            if (window.confirm("Do you want to upload the criteria weights?")) {
                // Confirm upload with user
                fetch('/project/createExcelCriteriaWeights', { //REST create project
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: this.state.email,
                        uid: this.props.match.params.projectid,
                        actid: this.state.MCAid, //get the id of actors
                        ExcelCriteriaWeights: data,
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            window.location.reload();
                        }
                        else {
                            message.error(json.message); //create unsuccessful, show alert
                        }
                    });
            }
        }
    };

    reader.readAsBinaryString(file);
    console.log(reader);

    // Prevent default upload behavior
    return false;
}

    //save all the form data of pairwise
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }

    //save all the form data of inGroupPairwise
    saveGFormRef = (formRef) => {
        this.GformRef = formRef;
    }
    //save all the form data of scale
    saveSFormRef = (formRef) => {
        this.SformRef = formRef;
    }

    //save all the form data of inGroup scale
    saveGSFormRef = (formRef) => {
        this.GSformRef = formRef;
    }
    saveMCAWeightsProp() {
        fetch('/project/saveMAMCAWeightsProp', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                actid: this.state.MCAid,
                MCACriteria: this.state.MCACriteria
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getMCACriteria(); //if success, refresh the criteria list
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });
    }

    saveMCAWeightsAbs(record) {
        fetch('/project/saveMAMCAWeightsAbs', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                actid: this.state.MCAid,
                MCACriterion: record
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getMCACriteria(); //if success, refresh the criteria list
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });

    }
    useSameWeight() {
        fetch('/project/useSameWeight', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                uid: this.props.match.params.projectid,
                actid: this.state.MCAid,
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getMCACriteria(); //if success, refresh the criteria list
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });
    }
    checkDisable() {
        if (this.state.totalWeight < 0.98) {
            return true
        }
        else {
            return false
        }
    }

    componentDidMount() {
        try {
            this.getMCACriteria() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const Step = Steps.Step;
        //the step infomation
        const mcaSteps = [{
            title: 'Alternatives',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];


        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };
        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });
        return <div className="MCACriteria">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                    <Col span={4}>
                        <h4>Project name: {this.state.projectName}</h4>
                    </Col>
                    <Col span={4}>
                        <h4>Evaluation type: {this.state.projectEvaluationType}</h4>
                    </Col>
                    <Col span={4}>
                        <h4>Role: {this.state.role}</h4>
                    </Col>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={2} onChange={this.onStepChange}>
                    {mcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showPairWiseModal}>Pairwise Comparison</Button>
                <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={this.showScaleModal}>100-Scale</Button>
                <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={() => { this.saveMCAWeightsProp() }}>Allocate weights proportionally</Button>
                <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={() => { this.useSameWeight() }}>Same weights as project manager</Button>
                <Button style={{ marginLeft: "2vh" }} size="large" onClick={this.showGraph}>Weight graph</Button>
                <Divider />
                <Text>Use excel to downlaod/upload data:&nbsp;</Text>
                <Button style={{ marginLeft: "0" }} onClick={this.downloadTemplate} > Download data in Excel</Button>

                <Upload accept=".xlsx,.xls" customRequest={({ file }) => this.uploadExcel(file)}>
                    <Button style={{ marginLeft: 8 }} type="primary" > Upload your data in Excel format</Button>
                </Upload>
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={columns}
                        components={components}
                        rowClassName={() => 'editable-row'}
                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.MCACriteria} //the data source is what we get after component mount
                    />
                </ConfigProvider>
                <Divider />
                <div className="steps-action">
                    {/* disabled={this.checkDisable()} */}
                    <Button size="large" type="primary" >
                        <Link to={`/invitedevaluation/${this.props.match.params.projectid}/${this.props.match.params.actorid}`}>Next</Link>
                    </Button>
                    <Button size="large" style={{ marginLeft: 8 }}>
                        <Link to={`/invitedcriteria/${this.props.match.params.projectid}/${this.props.match.params.actorid}`}>Previous</Link></Button>
                </div>
            </Spin>
            <PairwiseForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.pairWiseVisible}
                onCancel={this.handlePairWiseCancel}
                onCreate={this.handleCreate}
                onNext={this.handleNext}
                criteria={this.state.MCACriteria} //send criteria
            />

            <InGroupPairwiseForm
                wrappedComponentRef={this.saveGFormRef}
                visible={this.state.inGroupPairWiseVisible}
                onCancel={this.handleInGroupPairWiseCancel}
                onCreate={this.handleCreate}
                criteria={this.state.MCACriteria} //send criteria
            />

            <ScaleForm
                wrappedComponentRef={this.saveSFormRef}
                visible={this.state.scaleVisible}
                onCancel={this.handleScaleCancel}
                onCreate={this.handleScaleCreate}
                onNext={this.handleScaleNext}
                criteria={this.state.MCACriteria} //send criteria
            />

            <InGroupScaleForm
                wrappedComponentRef={this.saveGSFormRef}
                visible={this.state.inGroupScaleVisible}
                onCancel={this.handleInGroupScaleCancel}
                onCreate={this.handleScaleCreate}
                criteria={this.state.MCACriteria} //send criteria
            />
            <Modal
                title="Weight"
                visible={this.state.graphVisible}
                onOk={this.handleGraphOk}
                onCancel={this.handleGraphCancel}
                width={800}
            >
                <ReactEcharts
                    option={this.getWeightOption()}
                    onEvents={this.onEvents()}
                />
                <Row style={{ textAlign: "center" }} type="flex" justify="space-between" className="steps-action">
                    <Col span={8} offset={16} ><Button onClick={this.graphReset}>Back</Button></Col>
                </Row>
            </Modal>
        </div>;
    }
}